import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState={
    list:[]
}

const faqsSlice=createSlice({
    name:"faqs",
    initialState,
    reducers:{
        setFaqList:(state,action)=>{
            state.list=action.payload
        }
    }
})

export const {setFaqList}=faqsSlice.actions

export const getFAQListThunk=()=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/faqs","get")
            if(!res.err){
                dispatch(setFaqList(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load FAQs", severity: "error" }))
            }
        }catch(err){
            dispatch(setToast({ show: true, message: "Failed to load FAQs", severity: "error" }))
        }
    }
}

export default faqsSlice.reducer